import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile-page__subscriptions__list-item"
}
const _hoisted_2 = ["href", "textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "auto-renewal-container" }
const _hoisted_6 = {
  id: "ftc-auto-renewal",
  class: "ftc-auto-renewal form"
}
const _hoisted_7 = { class: "ftc-auto-renewal__checkbox" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "auto-renewal",
  class: "ftc-auto-renewal__checkbox-label"
}, " Auto Renewal ", -1)
const _hoisted_9 = { class: "switch" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1)

import { computed, watch, ref } from 'vue'

import Subscription from '../../../../../../global/js/magento-api-library/types/Subscription'
import formatDate from '../../../../utils/formatDate'
import { setSubscriptionStatus } from '../../../../../../global/js/magento-api-library/subscriptions/setSubscriptions'


export default /*#__PURE__*/_defineComponent({
  props: {
    subscription: null,
    issueUrl: null
  },
  setup(__props: any) {

const props = __props as {
  subscription: Subscription
  issueUrl: string
}



const expirationDate = computed((): string =>
  formatDate(props.subscription.next_run),
)
let isExpired = false

const currentDate = new Date()
const subscriptionDate = new Date(expirationDate.value)

if (subscriptionDate < currentDate) {
  isExpired = true
}

/* Cancel/Enable Auto-Renewal for FTC Guidelines */

/* Needed Variables */
/* boolean value to set the toggle switch */
const subscriptionStatus = ref(
  props.subscription.status === 'active' ? true : false,
)

/* Watch for changes in subscription status */
watch(subscriptionStatus, async () => {
  try {
    const subscriptionStatusString = subscriptionStatus.value
      ? 'active'
      : 'paused'
    await setSubscriptionStatus(
      props.subscription.entity_id,
      subscriptionStatusString,
    )
  } catch (error) {
    console.error('Error toggling subscription status:', error)
  }
})


return (_ctx: any,_cache: any) => {
  return (!_unref(isExpired))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.issueUrl !== '')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `${__props.issueUrl}`,
              class: "link profile-page__subscriptions__link",
              textContent: _toDisplayString(__props.subscription.description)
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "link profile-page__subscriptions__link",
              textContent: _toDisplayString(__props.subscription.description)
            }, null, 8, _hoisted_3)),
        _createElementVNode("span", {
          class: "profile-page__subscriptions__expiration-text",
          textContent: _toDisplayString(`Expiration: ${_unref(expirationDate)}`)
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("label", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  id: "auto-renewal",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subscriptionStatus).value = $event)),
                  type: "checkbox",
                  name: "auto-renewal",
                  checked: ""
                }, null, 512), [
                  [_vModelCheckbox, subscriptionStatus.value]
                ]),
                _hoisted_10
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})